import LocalizedStrings from "react-localization";
import { localeMk } from "./LocaleMk";

export const LOCALE = new LocalizedStrings({
  mk: localeMk,
});

if (localStorage.getItem("locale")) {
  LOCALE.setLanguage(localStorage.getItem("locale"));
} else {
  window.localStorage.setItem("locale", "mk");
  LOCALE.setLanguage("mk");
}

export const changeLanguage = (languageCode) => {
  var lng = window.localStorage.getItem("locale");
  if (typeof languageCode == "string" && (!lng || lng !== languageCode)) {
    window.localStorage.setItem("locale", languageCode);
    window.location.reload();
  }
};
